import {FunctionalModal} from "./FunctionalModal";
import styled from "styled-components";
import {BaseModal} from "./modalStyle";
import ExitButton from "../buttons/ExitButton";
import AddButtonFullText from "../buttons/AddButtonFullText";
import React, {useState} from "react";

import Links from "../link/Links";
import AddOrEditLinkModal from "./AddOrEditLinkModal";

const LinksModal = ({setIsOpen}) => {

    const close = () => {
        setIsOpen(false)
    }


    const [id, setId] = useState(0)

    const [openAddModal, setOpenAddModal] = useState(false)

    const displayModal = () => {
        if (openAddModal) {
            return <AddOrEditLinkModal setIsOpen={setOpenAddModal} id={id}/>
        }
    }

    return (
        <FunctionalModal setOpen={setIsOpen}
                         component={
                             <>
                                 {displayModal()}
                                 <Modal>
                                     <FirstSection>
                                         <h1> Les ressources externes / livrables du projet </h1>
                                         <ExitButton closeUpdate={close}/>
                                     </FirstSection>
                                     <AddButtonFullText
                                         id={id}
                                         setId={setId}
                                         setUpdate={setOpenAddModal}
                                         title={"Ajouter un lien "}
                                     />
                                     <Links/>
                                 </Modal>
                             </>
                         }/>
    )
}

export default LinksModal

const Modal = styled(BaseModal
)
    `
      position: unset;
      gap: 1rem;
      height: fit-content;
      align-items: center;

      .add-btn {
        //  max-width: 15rem;
      }

      @media (min-width: 800px) {
        position: absolute;
        width: 800px;
        height: 600px;
      }
      @media (min-width: 1200px) {
        width: 1000px;
        max-height: 700px;
      }
    `

const FirstSection = styled.div`
  display: flex;
  width: 100%;

  h1 {
    flex-grow: 1;
  }

  button {
    align-self: flex-start;
  }
`
